// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3vrRZ","savePackageButton":"ClientWallet_savePackageButton__1RePH"};